import { getSupabase, houseTableMapping, stayTypeMapping } from './supabaseClient';

// Fetch calendar data for all houses
export const fetchCalendarData = async (startDate, endDate) => {
  const calendarData = {};
  
  try {
    const supabase = await getSupabase();
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }

    // Query each house table - get only available records
    for (const [houseKey, tableName] of Object.entries(houseTableMapping)) {
      const { data, error } = await supabase
        .from(tableName)
        .select('check_in_date, status, price_status, stay_type, full_price')
        .eq('status', 'available')
        .eq('price_status', 'live')
        .gte('check_in_date', startDate)
        .lte('check_in_date', endDate)
        .order('check_in_date');

      if (error) {
        console.error(`Error fetching data for ${houseKey}:`, error);
        continue;
      }

      calendarData[houseKey] = data || [];
    }

    return calendarData;
  } catch (error) {
    console.error('Error fetching calendar data:', error);
    return {};
  }
};

// Check availability for specific house and date range
export const checkAvailability = async (houseKey, startDate, nights) => {
  const tableName = houseTableMapping[houseKey];
  if (!tableName) {
    throw new Error('Invalid house key');
  }

  const stayType = stayTypeMapping[nights];
  if (!stayType) {
    throw new Error('Invalid nights value');
  }

  try {
    const { data, error } = await supabase
      .from(tableName)
      .select('check_in_date, status, price_status, stay_type')
      .eq('check_in_date', startDate)
      .eq('status', 'available')
      .eq('price_status', 'live')
      .eq('stay_type', stayType);

    if (error) {
      throw error;
    }

    return data && data.length > 0;
  } catch (error) {
    console.error('Error checking availability:', error);
    return false;
  }
};

// Generate date range for calendar display
export const generateDateRange = (startDate, months = 6) => {
  const dates = [];
  const current = new Date(startDate);
  
  for (let i = 0; i < months; i++) {
    const year = current.getFullYear();
    const month = current.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    for (let day = 1; day <= daysInMonth; day++) {
      dates.push(new Date(year, month, day));
    }
    
    current.setMonth(current.getMonth() + 1);
  }
  
  return dates;
};

// Format date for display
export const formatDate = (date) => {
  const options = { 
    weekday: 'short', 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric' 
  };
  return date.toLocaleDateString('en-GB', options);
};

// Format date for API (YYYY-MM-DD) - avoid timezone issues
export const formatDateForAPI = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
